
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitopanchganicab() {



    const cardData =
    {
        keyword: ' Mumbai to Panchgani Cab   ',
        heading: 'Deva Cabs: Mumbai to Panchgani Cab   ',
        headingDescription: 'Deva Cabs offers reliable and comfortable cab services from Mumbai to Panchgani, ideal for hill station retreats, school trips, and weekend getaways. Located around 245 km from Mumbai, Panchgani is a serene destination nestled in the Sahyadri hills. Our cabs—ranging from Sedans to SUVs and Innova Crysta—ensure a smooth and enjoyable ride with professional drivers and well-maintained vehicles. With fixed pricing, timely pickups, and 24/7 availability, Deva Cabs makes your journey to Panchgani pleasant and hassle-free.',

        top: 'Top Places to Visit in Panchgani with Deva Cabs',

"topPlaces": [
  {
    "title": "Table Land",
    "location": "Panchgani, Maharashtra",
    "description": "Table Land is the second-largest volcanic plateau in Asia and the most famous attraction in Panchgani. Offering stunning views of the valleys, Dhom Dam, and nearby hills, it’s ideal for horse rides, sunrise walks, and paragliding. The flat terrain also hosts fairs, stalls, and local snacks for visitors."
  },
  {
    "title": "Sydney Point",
    "location": "Panchgani, Maharashtra",
    "description": "Sydney Point provides a panoramic view of the Dhom Dam, Kamalgad Fort, and the Krishna Valley. It’s especially popular during sunset when the sky turns golden over the water. The viewpoint is easily accessible and a must-visit for photographers and nature lovers."
  },
  {
    "title": "Parsi Point",
    "location": "Panchgani, Maharashtra",
    "description": "Parsi Point is a popular scenic spot offering sweeping views of the Krishna River valley and Dhom Dam. Surrounded by lush hills, it's a perfect place for families, with telescopes, snack stalls, and seating areas for a relaxing break during sightseeing."
  },
  {
    "title": "Devrai Art Village",
    "location": "Panchgani, Maharashtra",
    "description": "Devrai Art Village is a creative space where tribal artisans work with natural materials like stone, brass, iron, and wood. Visitors can view or purchase handcrafted items and learn about the cultural fusion of traditional art with contemporary design. A peaceful and inspiring stop in Panchgani."
  },
  {
    "title": "Rajpuri Caves",
    "location": "Near Panchgani, Maharashtra",
    "description": "Rajpuri Caves are a group of ancient rock-cut caves surrounded by sacred ponds. According to legend, the Pandavas spent time here during their exile. The caves also house a temple dedicated to Lord Kartikeya, and the atmosphere is deeply spiritual and historic."
  },
  {
    "title": "Harrison’s Folly",
    "location": "Panchgani, Maharashtra",
    "description": "Harrison’s Folly is a flat open plateau offering a 360-degree view of Panchgani and Wai. It’s a peaceful and less crowded viewpoint where visitors can enjoy nature, paragliding, and roadside refreshments. It’s ideal for short breaks and panoramic photography."
  },
  {
    "title": "Dhom Dam",
    "location": "Near Panchgani, Maharashtra",
    "description": "Dhom Dam is a serene backwater destination ideal for boating, nature walks, and picnics. The dam provides water to nearby towns and offers a peaceful escape with scenic beauty and reflections of surrounding hills. Perfect for sunset viewing and relaxed time in nature."
  },
  {
    "title": "Bhilar – Village of Books",
    "location": "Bhilar, Near Panchgani, Maharashtra",
    "description": "Bhilar is India's first 'village of books' where homes and public spaces are converted into free libraries. Visitors can explore Marathi literature in a unique, open-air setting. It's a cultural experience that combines rural tourism with the love of reading."
  },
  {
    "title": "Sherbaug Theme Park and Resort",
    "location": "Panchgani, Maharashtra",
    "description": "Sherbaug is a fun destination that includes a botanical garden, fossil park, horror house, and water activities. It’s a family-friendly spot with entertainment options for all ages, making it a unique blend of nature, science, and amusement."
  },
  {
    "title": "Wai Temples",
    "location": "Wai, Near Panchgani, Maharashtra",
    "description": "Just a short drive from Panchgani, Wai is known for its ancient temples like Dholya Ganapati and Kashi Vishweshwar, situated along the Krishna River. These temples are architecturally rich and spiritually significant, offering a peaceful cultural extension to your Panchgani trip."
  }
],



"services": [
  {
    "name": "Mumbai to Panchgani Cab",
    "description": "Enjoy a scenic and relaxing journey from Mumbai to Panchgani with Deva Cabs’ trusted outstation cab service. Covering approximately 250 km, this route offers beautiful views and fresh mountain air. Our cab service ensures a smooth ride with comfortable vehicles, reliable drivers, and flexible booking options — ideal for families, couples, or small groups looking to unwind in the hills."
  },
  {
    "name": "Book cab Mumbai to Panchgani",
    "description": "Reserve your cab from Mumbai to Panchgani easily with Deva Cabs’ online booking platform. Choose from sedans, SUVs, or premium cars with instant confirmation. Our system offers transparent pricing, flexible schedules, and real-time tracking so you can focus on your trip, not the logistics."
  },
  {
    "name": "One-way taxi Mumbai to Panchgani",
    "description": "Save money on single journeys with Deva Cabs’ one-way taxi service to Panchgani. Whether you're heading for a retreat or relocating temporarily, our one-way service ensures no return fare is charged. Get a clean, well-maintained cab with a professional driver for your one-direction trip."
  },
  {
    "name": "Chauffeur cab Mumbai to Panchgani",
    "description": "Travel in comfort and peace with our chauffeur-driven cab service to Panchgani. Our trained drivers offer door-to-door service, route expertise, and friendly support throughout the journey. Whether you’re heading for leisure or work, you’ll reach your destination stress-free and safe."
  },
  {
    "name": "SUV cab hire Mumbai to Panchgani",
    "description": "Heading to Panchgani with a group or lots of luggage? Our SUV cabs offer extra space, power, and comfort for the winding hilly terrain. Ideal for families or groups of 5–7 people, our SUVs provide great suspension, ample legroom, and a stable ride even through mountain curves."
  },
  {
    "name": "AC taxi Mumbai to Panchgani",
    "description": "Beat the heat with our fully air-conditioned taxis from Mumbai to Panchgani. No matter the season, our AC vehicles ensure a cool, clean, and refreshing cabin experience. It’s the perfect option for a relaxed journey, especially during summer months."
  },
  {
    "name": "Luxury car Mumbai to Panchgani",
    "description": "Upgrade your hill-station travel with our luxury cab service from Mumbai to Panchgani. Enjoy premium interiors, leather seats, and executive-grade vehicles like Innova Crysta, BMW, or Audi (on request). Best for VIP travelers, couples, or anyone seeking elegance in every mile."
  },
  {
    "name": "Family cab Mumbai to Panchgani",
    "description": "Traveling with kids or elders? Deva Cabs offers safe and family-friendly cabs to Panchgani. Our cars come with roomy seating, boot space for extra luggage, and drivers trained to handle family travel needs like rest stops or extra care on winding roads."
  },
  {
    "name": "Mumbai to Panchgani sightseeing cab",
    "description": "Add more fun to your trip with a sightseeing cab from Mumbai to Panchgani. Stop at scenic points en route or explore Panchgani’s attractions like Table Land, Parsi Point, and Sydney Point. Our drivers can suggest spots or follow your custom plan for a memorable ride."
  },
  {
    "name": "Affordable Panchgani taxi from Mumbai",
    "description": "Looking for an economical way to reach Panchgani? Our affordable taxi service gives you the best rates for well-maintained vehicles, verified drivers, and transparent billing. No hidden charges — just dependable service for budget-conscious travelers."
  },
  {
    "name": "Weekend cab hire Mumbai to Panchgani",
    "description": "Deva Cabs offers special weekend cab packages for travelers planning a short escape to Panchgani. Get customized pickup and drop schedules, round-trip options, and discounted pricing when you book Friday-to-Sunday cabs. Perfect for couples and friend groups."
  },
  {
    "name": "Premium taxi Mumbai to Panchgani",
    "description": "Travel in unmatched comfort with our premium taxi service to Panchgani. Enjoy spacious seating, professional chauffeur support, and top-class vehicle quality. This service is ideal for clients, executives, or travelers who prefer high-end comfort over long distances."
  },
  {
    "name": "Round trip cab Mumbai to Panchgani",
    "description": "Need to go and return with the same car? Book our round-trip cab from Mumbai to Panchgani and enjoy the flexibility of keeping your cab with you throughout your stay. Whether for a 2-day trip or longer, this service guarantees a stress-free return ride."
  },
  {
    "name": "Corporate cab Mumbai to Panchgani",
    "description": "Send your staff, clients, or guests to Panchgani with our reliable corporate taxi service. We offer GST billing, timely pickups, and professional drivers suited for executive travel. Great for offsites, business retreats, and hospitality services."
  },
  {
    "name": "Online Panchgani cab booking Mumbai",
    "description": "Book your Mumbai to Panchgani cab online in just a few clicks with Deva Cabs. Our mobile-friendly platform provides fare estimates, vehicle choices, and instant confirmation. A smooth digital experience for travelers who value convenience and control."
  }
],
"tableData": [
  ["Mumbai to Panchgani Cab", "-Book cab Mumbai to Panchgani"],
  ["One-way taxi Mumbai to Panchgani", "-Chauffeur cab Mumbai to Panchgani"],
  ["SUV cab hire Mumbai to Panchgani", "-AC taxi Mumbai to Panchgani"],
  ["Luxury car Mumbai to Panchgani", "-Family cab Mumbai to Panchgani"],
  ["Mumbai to Panchgani sightseeing cab", "-Affordable Panchgani taxi from Mumbai"],
  ["Weekend cab hire Mumbai to Panchgani", "-Premium taxi Mumbai to Panchgani"],
  ["Round trip cab Mumbai to Panchgani", "-Corporate cab Mumbai to Panchgani"],
  ["Online Panchgani cab booking Mumbai", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Panchgani Cab Service",
    "WhyChoosedescription": "Our Mumbai to Panchgani cab service offers punctual and dependable transportation for travelers seeking a peaceful hill station escape. Whether it's a family vacation, a weekend trip, or a romantic getaway, we ensure timely pick-up and smooth journey from Mumbai to Panchgani, providing a hassle-free and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Scenic Travel",
    "WhyChoosedescription": "Enjoy the breathtaking drive through the Western Ghats in our well-maintained, air-conditioned vehicles. Our fleet offers ample legroom, clean interiors, and sufficient luggage space, making the approximately 4-5 hour journey to Panchgani relaxing and enjoyable for solo travelers, couples, and groups alike."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Hill Station Routes",
    "WhyChoosedescription": "Our drivers are proficient in navigating the winding roads leading to Panchgani, ensuring a safe and smooth ride. Their knowledge of local routes and traffic conditions helps avoid delays, allowing you to make the most of your time at this beautiful hill station."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We provide upfront pricing that includes fuel, tolls, and driver allowances, with no hidden charges. Our competitive rates make luxury travel affordable, allowing you to plan your trip budget confidently."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Schedules",
    "WhyChoosedescription": "Whether you prefer an early morning departure or a late-night return, our cabs are available round the clock to fit your schedule. We accommodate last-minute bookings and ensure timely service on weekends and holidays as well."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Panchgani cab is quick and hassle-free through our website or customer support. Receive instant booking confirmation and driver details, allowing you to plan your trip with confidence and ease."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential safety features like seat belts and GPS tracking. Our drivers strictly adhere to safety protocols, especially on hilly terrains, to ensure a secure and pleasant journey."
  },
  {
    "WhyChooseheading": "Customized Travel Packages Tailored to Your Needs",
    "WhyChoosedescription": "We offer flexible travel options including one-way trips, round trips, and multiple stopovers. Whether you’re traveling solo, with family, or in a group, we tailor our services to your itinerary, ensuring a personalized and stress-free travel experience."
  }
]








    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Panchgani with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable cab services from Mumbai to Panchgani for leisure trips, weekend getaways, and family vacations."
  },
  {
    question: "How long is the drive from Mumbai to Panchgani by cab?",
    answer: "The journey typically takes around 5 to 6 hours, depending on the traffic and road conditions."
  },
  {
    question: "What vehicle options are available for the Mumbai to Panchgani route?",
    answer: "You can choose from sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your group size and comfort preferences."
  },
  {
    question: "Is advance booking available for Mumbai to Panchgani cabs?",
    answer: "Yes, you can pre-book your cab via our website, app, or by calling our customer support team."
  },
  {
    question: "Are one-way trips from Mumbai to Panchgani available?",
    answer: "Yes, Deva Cabs offers convenient and affordable one-way cab services without return fare requirements."
  },
  {
    question: "Are tolls, parking, and driver charges included in the fare?",
    answer: "These charges are generally additional and will be clearly mentioned during the booking process."
  },
  {
    question: "Is it safe to travel to Panchgani by cab, especially for solo or female travelers?",
    answer: "Absolutely. All our drivers are background-verified and trained to ensure a safe and pleasant journey."
  },
  {
    question: "Can I book a round-trip package from Mumbai to Panchgani?",
    answer: "Yes, round-trip options are available for same-day return or extended stays with flexible pricing."
  },
  {
    question: "Is the cab service available at night or early in the morning?",
    answer: "Yes, our services operate 24/7 to accommodate your preferred travel time."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Panchgani cab service?",
    answer: "Deva Cabs ensures clean vehicles, professional drivers, punctual service, and transparent pricing for a stress-free experience."
  }
];

const testimonialData = [
  {
    id: 41,
    name: 'Mr. Saurabh Naik',
    role: 'Weekend Explorer',
    review: 'Booked a cab with Deva Cabs for a trip to Panchgani. The ride was super comfortable and the driver was very professional. Will definitely use again!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 42,
    name: 'Ms. Ayesha Merchant',
    role: 'Tourist',
    review: 'Our Mumbai to Panchgani cab was perfectly on time, clean, and safe. The whole experience was smooth and hassle-free. Highly recommend Deva Cabs!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-panchgani-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Panchgani cab with Deva Cabs. Offering AC, SUV, luxury, chauffeur-driven cabs for one-way, round trip, family, corporate, and sightseeing trips. Easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5900",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-panchgani-cab" // Replace with actual page URL
  }
};



    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Panchgani Cab | Reliable & Affordable Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Panchgani cab with Deva Cabs. AC, SUV, luxury, and chauffeur-driven cabs available for one-way, round trip, family, corporate, and sightseeing trips. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Panchgani Cab, Book cab Mumbai to Panchgani, One-way taxi Mumbai to Panchgani, Chauffeur cab Mumbai to Panchgani, SUV cab hire Mumbai to Panchgani, AC taxi Mumbai to Panchgani, Luxury car Mumbai to Panchgani, Family cab Mumbai to Panchgani, Mumbai to Panchgani sightseeing cab, Affordable Panchgani taxi from Mumbai, Weekend cab hire Mumbai to Panchgani, Premium taxi Mumbai to Panchgani, Round trip cab Mumbai to Panchgani, Corporate cab Mumbai to Panchgani, Online Panchgani cab booking Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitopanchganicab;